import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { TagDesktop } from '../../../../tag/esm/desktop';

var styles = {"tag":"pagination__tag_1w95k","checked":"pagination__checked_1w95k"};
require('./index.css');

var Tag = function (_a) {
    var _b;
    var className = _a.className, checked = _a.checked, restProps = __rest(_a, ["className", "checked"]);
    return (React.createElement(TagDesktop, __assign({}, restProps, { checked: checked, size: 'xxs', className: cn(className, styles.tag, (_b = {}, _b[styles.checked] = checked, _b)) })));
};

export { Tag };
